let count;

if (window.matchMedia('(max-width: 767px)').matches) {
  let count = 2;
} else if (window.matchMedia('(min-width:768px)').matches) {
  let count = 3;
}

////////////////// 慣性スクロール
if (window.matchMedia('(max-width: 767px)').matches) {
  //スマホ処理
  console.log("スマホだよ")
} else if (window.matchMedia('(min-width:768px)').matches) {
  const lenis = new Lenis({
    duration: 1.2, // アニメーションの継続時間
    direction: 'vertical', // 方向
    gestureDirection: 'vertical',
    smooth: true, // スムーススクロールの有効・無効を設定
    smoothTouch: false, // タッチスクロール時のスムーススクロールの有効・無効を設定。(タッチデバイス本来の滑らかさを模倣することは不可能であるため、デフォルト無効)
    touchMultiplier: 2,
  })
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf)
}


////////////////// スクロール

const list = document.querySelectorAll(".fade")
list.forEach(function(element, i) {
  gsap.fromTo(
    list[i], // アニメーションさせる要素
    {opacity: 0,y: 30,},
    {
      opacity: 1,y: 0,duration: 0.3,
      scrollTrigger: {
        trigger: list[i],
        toggleActions: "play none none none", 
        start: "top-=200 center", 
        // markers: true,
      },
    }
  );
});


//////////////////// 車
gsap.timeline({
  scrollTrigger: {
    trigger: ".car_h3",
    scrub: 1,
    start: "center center",
    toggleActions: "play none none none",
    end: "+=100",
  }
}).fromTo(
  ".ccg_car_car", // アニメーションさせる要素
  {opacity: 0,scale: 0,},
  {opacity: 1,scale: 1,}
).fromTo(
  ".ccg_car_desc01", // アニメーションさせる要素
  {opacity: 0,scale: 0,},
  {opacity: 1,scale: 1,}
).fromTo(
  ".ccg_car_desc02", // アニメーションさせる要素
  {opacity: 0,scale: 0,},
  {opacity: 1,scale: 1,}
)



//////////////////// text
const list_text_all = document.querySelectorAll(".TextAnim")
list_text_all.forEach(function(element, i) {
  list_text_all[i].innerHTML = list_text_all[i].textContent.replace(/\S/g, "<span class='letter" + i + "'>$&</span>");
  let letter = document.querySelectorAll(".letter" + i);
  gsap.fromTo(
    letter, // アニメーションさせる要素
    {opacity: 0,y: 10,},
    {
      opacity: 1,y: 0,duration: 0.6,
      scrollTrigger: {
        trigger: list_text_all[i],
        toggleActions: "play none none none", 
        start: "top-=200 center", 
        // markers: true,
      },
      stagger: {
        each: .01, // 遅延させる時間
      }
    }
  );
});



//////////////////// 車_pc
const car_all = document.querySelectorAll(".car_car")
car_all.forEach(function(element, i) {
  gsap.timeline({
    scrollTrigger: {
      trigger: car_all[i],
      scrub: 1,
      start: "center-300 center",
      end: "+=1500",
      // markers: true,
    }
  }).to(car_all[i], {
    x: "+=970",
  }).to(car_all[i], {
    rotate: "+=90",
    y: "+=150",
    duration: 0.1
  },"-=0.12").to(car_all[i], {
    y: "+=520",
  }).to(car_all[i], {
    rotate: "+=90",
    x: "-=100",
    duration: 0.15,
  },"-=0.1").to(car_all[i], {
    x: "-=960",
  }).to(car_all[i], {
    rotate: "-=90",
    y: "+=80",
    duration: 0.1
  },"-=0.1").to(car_all[i], {
    y: "+=310",
  }).to(car_all[i], {
    rotate: "-=90",
    x: "+=50",
    duration: 0.1
  },"-=0.1").to(car_all[i], {
    x: "+=1020",
  }).to(car_all[i], {
    rotate: "+=90",
    y: "+=150",
    duration: 0.2
  },"-=0.12").to(car_all[i], {
    y: "+=420",
  }).to(car_all[i], {
    opacity: "0",
    duration: 0.1,
  },"-=0.1")
});


//////////////////// 車_sp_1
const car_all_sp_1 = document.querySelector(".car_car_sp_1")
gsap.timeline({
  scrollTrigger: {
    trigger: car_all_sp_1,
    scrub: 1,
    start: "center center",
    end: "+=1800",
    // markers: true,
  }
}).to(car_all_sp_1, {
  y: "+=600",
}).to(car_all_sp_1, {
  rotate: "-=90",
  x: "+=30",
  duration: 0.1
},"-=0.01").to(car_all_sp_1, {
  x: "+=290",
}).to(car_all_sp_1, {
  rotate: "+=90",
  y: "+=30",
  duration: 0.1
},"-=0.01").to(car_all_sp_1, {
  y: "+=520",
}).to(car_all_sp_1, {
  rotate: "+=90",
  x: "-=60",
  duration: 0.1
},"-=0.01").to(car_all_sp_1, {
  x: "-=250",
}).to(car_all_sp_1, {
  rotate: "-=90",
  y: "+=60",
  duration: 0.1
}).to(car_all_sp_1, {
  y: "+=550",
}).to(car_all_sp_1, {
  opacity: "0",
  duration: 0.1,
},"-=0.1")


//////////////////// 車_sp_2
const car_all_sp_2 = document.querySelector(".car_car_sp_2")
gsap.timeline({
  scrollTrigger: {
    trigger: car_all_sp_2,
    scrub: 1,
    start: "center center",
    end: "+=2200",
    // markers: true,
  }
}).to(car_all_sp_2, {
  y: "+=880",
}).to(car_all_sp_2, {
  rotate: "-=90",
  x: "+=30",
  duration: 0.1
},"-=0.01").to(car_all_sp_2, {
  x: "+=290",
}).to(car_all_sp_2, {
  rotate: "+=90",
  y: "+=30",
  duration: 0.1
},"-=0.01").to(car_all_sp_2, {
  y: "+=520",
}).to(car_all_sp_2, {
  rotate: "+=90",
  x: "-=60",
  duration: 0.1
},"-=0.01").to(car_all_sp_2, {
  x: "-=250",
}).to(car_all_sp_2, {
  rotate: "-=90",
  y: "+=60",
  duration: 0.1
}).to(car_all_sp_2, {
  y: "+=900",
}).to(car_all_sp_2, {
  opacity: "0",
  duration: 0.1,
},"-=0.1")


//////////////////// 車_sp_3
const car_all_sp_3 = document.querySelector(".car_car_sp_3")
gsap.timeline({
  scrollTrigger: {
    trigger: car_all_sp_3,
    scrub: 1,
    start: "center center",
    end: "+=2200",
    // markers: true,
  }
}).to(car_all_sp_3, {
  y: "+=920",
}).to(car_all_sp_3, {
  rotate: "-=90",
  x: "+=30",
  duration: 0.1
},"-=0.01").to(car_all_sp_3, {
  x: "+=290",
}).to(car_all_sp_3, {
  rotate: "+=90",
  y: "+=30",
  duration: 0.1
},"-=0.01").to(car_all_sp_3, {
  y: "+=520",
}).to(car_all_sp_3, {
  rotate: "+=90",
  x: "-=60",
  duration: 0.1
},"-=0.01").to(car_all_sp_3, {
  x: "-=250",
}).to(car_all_sp_3, {
  rotate: "-=90",
  y: "+=60",
  duration: 0.1
}).to(car_all_sp_3, {
  y: "+=900",
}).to(car_all_sp_3, {
  opacity: "0",
  duration: 0.1,
},"-=0.1")



//////////////////// 車_sp_4
const car_all_sp_4 = document.querySelector(".car_car_sp_4")
gsap.timeline({
  scrollTrigger: {
    trigger: car_all_sp_4,
    scrub: 1,
    start: "center center",
    end: "+=1800",
    // markers: true,
  }
}).to(car_all_sp_4, {
  y: "+=660",
}).to(car_all_sp_4, {
  rotate: "-=90",
  x: "+=30",
  duration: 0.1
},"-=0.01").to(car_all_sp_4, {
  x: "+=290",
}).to(car_all_sp_4, {
  rotate: "+=90",
  y: "+=30",
  duration: 0.1
},"-=0.01").to(car_all_sp_4, {
  y: "+=500",
}).to(car_all_sp_4, {
  rotate: "+=90",
  x: "-=60",
  duration: 0.1
},"-=0.01").to(car_all_sp_4, {
  x: "-=250",
}).to(car_all_sp_4, {
  rotate: "-=90",
  y: "+=60",
  duration: 0.1
}).to(car_all_sp_4, {
  y: "+=550",
}).to(car_all_sp_4, {
  opacity: "0",
  duration: 0.1,
},"-=0.1")